<template>
  <div class="news">
    <div class="banner">
      <img src="../assets/news_banner.png" alt />
    </div>
    <h2>新闻动态</h2>
    <div class="news-list">
      <div class="category">
        <div>平台公告</div>
      </div>
      <ul>
        <li class="news-item">
          <router-link to="/news-detail">
            <img src="../assets/news_brief.png" alt />
            <div class="abstract">
              <h4 class="title">三一金票服务平台上线公告</h4>
              <div class="time">2019/12/06</div>
              <div class="content">尊敬的用户：您好！三一金票服务平台于12月6日完成上线，为方便您了解平台及...</div>
            </div>
          </router-link>
        </li>
        <li class="news-item">
          <router-link to="/news-detail-2">
            <img src="../assets/news_brief_2.png" alt />
            <div class="abstract">
              <h4 class="title">共克时艰，金票相伴！</h4>
              <div class="time">2020/03/28</div>
              <div class="content">抗疫复工，三一在行动。在做好自身复工复产工作的同时，三一持续关注合作供应商...</div>
            </div>
          </router-link>
        </li>
        <li></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less">
.news {
  .banner {
    img {
      height: 250px;
      width: 100%;
    }
  }
  h2 {
    margin-top: 74px;
    margin-bottom: 44px;
    font-size: 48px;
    text-align: center;
  }
  .news-list {
    padding-left: 30px;
    padding-right: 30px;
    margin-bottom: 90px;
    .category {
      border-bottom: 1px solid #dcdcdc;
      font-size: 32px;
      div {
        color: @primary;
        width: 132px;
        border-bottom: 4px solid @primary;
        padding: 10px 0;
      }
    }
    .news-item {
      padding: 40px 0;
      border-bottom: 1px solid #dcdcdc;
      .abstract {
        display: inline-block;
      }
      img {
        width: 200px;
        height: 200px;
        margin-right: 32px;
        // vertical-align: baseline;
        display: inline-block;
      }
      .title {
        color: #333;
        font-size: 32px;
        font-weight: bold;
      }
      .time {
        color: #666;
        font-size: 22px;
        margin-top: 60px;
        margin-bottom: 22px;
      }
      .content {
        color: #333;
        font-size: 24px;
        width: 456px;
      }
    }
  }
}
</style>
